import { createVanIconComponent } from "./van"

const PhoneCircleOutlined = createVanIconComponent("phone-circle-o")
export default PhoneCircleOutlined
